module.exports = __webpack_public_path__ + "img/Duplicate.132755ff.svg";